export function isContentEmpty(content: string): boolean {
  return (content || '').replace(/<[^>]*>/g, '').trim().length === 0;
}

export function extractTextContent(richText: string): string {
  return richText && richText.replace(/<\/?[^>]+>/gi, '');
}
